import axios from 'axios';
import { navigateTo } from '../utils/navigation';

import {
  getAccessToken,
  getRefreshToken,
  setAccessToken,
  clearTokens,
} from '../services/tokenService';


const BASE_URL = 'https://paqtory.com/api'; // Update with your API base URL

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach access token to every request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAccessToken();

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {

    return Promise.reject(error);
  }
);

// Handle token refresh and errors
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshToken = getRefreshToken();

        if (!refreshToken) {
          throw new Error('No refresh token available');
        }

        // Attempt to refresh the access token
        const response = await axios.post(`${BASE_URL}/user/refresh_token/`, {
          refresh_token: refreshToken,
        });

        //  check status code 
        if (response.status !== 401) {
          throw new Error('Failed to refresh token');
        }
        const newAccessToken = response.data.access_token;

        // Update the access token
        setAccessToken(newAccessToken);

        // Retry the original request with the new token
        originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
        return axiosInstance(originalRequest);
      } catch (err) {


        clearTokens();
        navigateTo('/login');
        // return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
